import React, { useEffect, useState } from 'react';
import DOMPurify from 'dompurify';
import { getCurrentDomain } from '../config/domains';
import { CMSPageContent, getCMSPage } from '../services/api';

const Services: React.FC = () => {
  const domain = getCurrentDomain();
  const [content, setContent] = useState<CMSPageContent | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    getCMSPage('services').then((res) => {
      if (res.error) setError(res.error);
      else if (res.data) setContent(res.data);
      setLoading(false);
    });
  }, []);

  if (loading) return <div className="loading">Loading...</div>;
  if (error) return <div className="error">Error loading content: {error}</div>;

  const fields = content?.fields ?? {};
  const services = content?.blocks?.services ?? [];

  return (
    <div>
      <div className="page-header">
        {fields.headline && (
          <h1 className="page-title" style={{ color: domain.primaryColor }}>{fields.headline}</h1>
        )}
      </div>

      <div className="page-content">
        {fields.intro && <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(fields.intro) }} />}

        {services.length > 0 && (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '1.5rem', marginTop: '2rem' }}>
            {services.map((block) => (
              <div key={block.id} style={{ padding: '1.25rem', border: '1px solid #eee', borderRadius: '6px', backgroundColor: '#fafafa' }}>
                <h3 style={{ color: domain.primaryColor, marginTop: 0 }}>{block.fields.title}</h3>
                {block.fields.body && <div style={{ margin: 0, color: '#555' }} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(block.fields.body) }} />}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Services;
